import { useState } from 'react';
import { Copy, Check, ChevronDown } from 'lucide-react';
import { copyToClipboard } from '../storyboardApi';

// Generic flat Campaign Package module card with individual copy button.
export const CopyCard = ({ index, title, text, children, collapsible = false, testId }) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(!collapsible);

  const copy = async () => {
    await copyToClipboard(text || '');
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div className="rounded-2xl border border-gray-200/50 bg-white/40 p-4" data-testid={testId}>
      <div className="flex items-center justify-between gap-2">
        <button
          onClick={() => collapsible && setOpen(v => !v)}
          className={`flex items-center gap-2 text-left ${collapsible ? 'cursor-pointer' : 'cursor-default'}`}
        >
          <span className="text-[10px] font-mono text-gray-400 w-5">{String(index).padStart(2, '0')}</span>
          <span className="text-sm font-medium text-gray-900">{title}</span>
          {collapsible && <ChevronDown className={`w-3.5 h-3.5 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />}
        </button>
        <button
          data-testid={`${testId}-copy`}
          onClick={copy}
          disabled={!text}
          className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[11px] font-medium bg-white/60 border border-gray-200/60 text-gray-600 hover:text-gray-900 hover:bg-white/80 transition-all disabled:opacity-40 shrink-0"
        >
          {copied ? <Check className="w-3 h-3 text-green-600" /> : <Copy className="w-3 h-3" />}
          <span>{copied ? 'Copied' : 'Copy'}</span>
        </button>
      </div>
      {open && (
        <div className="mt-2.5 pl-7">
          {children || (
            <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-wrap">{text || '—'}</p>
          )}
        </div>
      )}
    </div>
  );
};
